module.exports = "<p>\n  telecaller-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller-details/telecaller-details.component.html
// module id = ./src/app/prospect/telecaller-details/telecaller-details.component.html
// module chunks = main